import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import CaleoPrimaryButton from 'Components/reusable/Buttons/CaleoPrimaryButton'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { getWizardPath } from './wizardSteps'

/** @notExported */
interface IWizardStartCardProps {
  /** ID of the profile's person. */
  personId: number
  /** ID of the empty CV. */
  cvId: number
}

/**
 * Card shown on an empty CV that invites the user to fill the CV with the wizard.
 *
 * @returns Start wizard card.
 * @notExported
 */
const WizardStartCard: React.FC<IWizardStartCardProps> = ({ personId, cvId }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  // Same width as the profile cards below: the containers match `ProfilePageCards`' outer layout.
  return (
    <Grid container justifyContent="center" sx={{ px: 1, mb: 3 }}>
      <Grid sx={{ maxWidth: '1400px !important' }} size={12}>
        <Paper data-testid="wizard-start-card" sx={{ p: 3 }}>
          <Grid container spacing={2} alignItems="center" justifyContent="space-between">
            <Grid size={{ xs: 12, md: 'grow' }}>
              <Typography variant="h5" sx={{ mb: 1 }}>
                {t('profile.wizard.start.title')}
              </Typography>
              <Typography>{t('profile.wizard.start.text')}</Typography>
            </Grid>
            <Grid>
              <CaleoPrimaryButton
                testId="button-wizard-start"
                valid={true}
                label={t('profile.wizard.start.button')}
                clickAction={() => navigate(getWizardPath(personId, cvId))}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default WizardStartCard
